import React, { Component } from "react";
import { connect } from "react-redux";
import { contentClient, discussionClient } from "../../../AxiosClient";
import InfoIcon from "@material-ui/icons/Info";
import MessageIcon from "@material-ui/icons/Message";
import ItemContentRevision from "../../list-item/ItemContentRevision";

import Button from "@material-ui/core/Button";
import SwipeableViews from "react-swipeable-views";
import DisplayTemplate from "../DisplayTemplate";

import { KeyboardDatePicker } from "@material-ui/pickers";
import Skeleton from "@material-ui/lab/Skeleton";

import Alert from "@material-ui/lab/Alert";
import { withTranslation, Trans } from "react-i18next";
import CreateContentFlow from "../../content/CreateContentFlow";
// import { Link } from "react-router-dom";
import Link from "@material-ui/core/Link";
import Tooltip from "@material-ui/core/Tooltip";
import DiffRevisions from "../DiffRevisions";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { withRouter } from "react-router";
import DocumentType from "../../DocumentType";
// import { useRouteMatch } from "react-router-dom";
import { withSnackbar } from "notistack";

import KnowledgeItemDiscussion from "./KnowledgeItemDiscussion";
// import "material-icons/iconfont/material-icons.css";
import DisplayUser from "../../user/DisplayUser";

import { Table, TableBody, TableRow, TableCell, Paper } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import { withStyles, withTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

import moment from "moment";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SaveIcon from "@material-ui/icons/Save";
import ReplayIcon from "@material-ui/icons/Replay";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";
import FlagIcon from "@material-ui/icons/Flag";
import HistoryIcon from "@material-ui/icons/History";

import RevisionSummaryTimeline from "./RevisionSummaryTimeline";
import DocumentViewer from "../../DocumentViewer";
import { Badge } from "@material-ui/core";
import SidebarRework from "../../rework/SidebarRework";
import DocumentSidebar from "../../document/DocumentSidebar";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import SvgIcon from "@material-ui/core/SvgIcon";
import Avatar from "@material-ui/core/Avatar";
import Container from "@material-ui/core/Container";
import TaxonomySelector from "../../taxonomy/TaxonomySelector";
import DocumentCategories from "../../document/DocumentCategories";
import FilterWrapper from "../../filter/FilterWrapper";
import PropertyNames from "../../../PropertyNames";
import KpsTextField from "../../KpsTextField";

import { Virtuoso } from "react-virtuoso";
import { AutoSizer } from "react-virtualized";

const styles = (theme) => ({
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 120,
  },
  blue: {
    color: theme.palette.info.main,
  },
  green: {
    color: theme.palette.success.main,
  },
  red: {
    color: theme.palette.error.main,
  },
  line: {
    paddingTop: 8,
    display: "flex",
  },
  divider: {
    marginTop: "20px",
  },
  lineValue: {
    width: "100%",
  },
  lineHeader: {
    // width: "40%",
  },
  displayTemplate: {
    "& > div .page": {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  tableCell: {
    verticalAlign: "top",
  },
  tableCellNoBorder: {
    border: "0",
  },
  paper: {
    padding: "6px 16px",
  },
  tabTitle: {
    flexDirection: "row",
  },
  spacedButton: {
    margin: theme.spacing(2),
  },
  docViewer: {
    display: "flex",
  },
  // listItem: {
  //   marginLeft: theme.spacing(0),
  // },
  // listItemAvatar: {
  //   marginRight: theme.spacing(1),
  // },
  publishedAvatar: {
    height: theme.spacing(5),
    width: theme.spacing(5),
    marginRight: theme.spacing(1),
    fontSize: "small",
    backgroundColor: theme.palette.success.main,
  },
  waitingAvatar: {
    height: theme.spacing(5),
    width: theme.spacing(5),
    marginRight: theme.spacing(1),
    fontSize: "small",
    backgroundColor: theme.palette.warning.main,
  },
  draftAvatar: {
    height: theme.spacing(5),
    width: theme.spacing(5),
    marginRight: theme.spacing(1),
    fontSize: "small",
    backgroundColor: theme.palette.info.main,
  },
  disabledAvatar: {
    height: theme.spacing(5),
    width: theme.spacing(5),
    marginRight: theme.spacing(1),
    fontSize: "small",
    backgroundColor: theme.palette.common.white,
  },
  settingsCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  settingsCardContent: {
    flex: 1,
  },
});
const equal = require("deep-equal");
const topicSVG =
  "M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z";

const reviewer =
  "M20,2H4A2,2 0 0,0 2,4V16A2,2 0 0,0 4,18H8L12,22L16,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M12,4.3C13.5,4.3 14.7,5.5 14.7,7C14.7,8.5 13.5,9.7 12,9.7C10.5,9.7 9.3,8.5 9.3,7C9.3,5.5 10.5,4.3 12,4.3M18,15H6V14.1C6,12.1 10,11 12,11C14,11 18,12.1 18,14.1V15Z";
const approver =
  "M21.1,12.5L22.5,13.91L15.97,20.5L12.5,17L13.9,15.59L15.97,17.67L21.1,12.5M10,17L13,20H3V18C3,15.79 6.58,14 11,14L12.89,14.11L10,17M11,4A4,4 0 0,1 15,8A4,4 0 0,1 11,12A4,4 0 0,1 7,8A4,4 0 0,1 11,4Z";
const published =
  "M17,21L14.25,18L15.41,16.84L17,18.43L20.59,14.84L21.75,16.25M12.8,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V12.8C20.12,12.29 19.09,12 18,12L17,12.08V11H7V13H14.69C13.07,14.07 12,15.91 12,18C12,19.09 12.29,20.12 12.8,21M12,15H7V17H12M17,7H7V9H17";
const waiting =
  "M6,2H18V8H18V8L14,12L18,16V16H18V22H6V16H6V16L10,12L6,8V8H6V2M16,16.5L12,12.5L8,16.5V20H16V16.5M12,11.5L16,7.5V4H8V7.5L12,11.5M10,6H14V6.75L12,8.75L10,6.75V6Z";
const draft =
  "M8,12H16V14H8V12M10,20H6V4H13V9H18V12.1L20,10.1V8L14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H10V20M8,18H12.1L13,17.1V16H8V18M20.2,13C20.3,13 20.5,13.1 20.6,13.2L21.9,14.5C22.1,14.7 22.1,15.1 21.9,15.3L20.9,16.3L18.8,14.2L19.8,13.2C19.9,13.1 20,13 20.2,13M20.2,16.9L14.1,23H12V20.9L18.1,14.8L20.2,16.9Z";
const editInProgress =
  "M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z";
const superseded =
  "M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z";
const removedFromDraft =
  "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z";
// function Alert(props) {
//   return <MuiAlert elevation={6} variant="filled" {...props} />;
// }
class KnowledgeItemView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      knowledgeItem: {},
      tempKnowledgeItem: {},
      revisions: [],
      selected: 0,
      selectedRevision: {},
      author: {},
      modifiedBy: {},
      approvedBy: {},
      snackOpen: false,
      createRevision: false,
      liveRevision: null,
      marks: [],
      hasBeenEdited: false,
      editViewedRevision: false,
      resolvingReworks: [],
      diff: false,
      diffRevisionNumber: null,
      sidebarOpen: false,
      // filters: {
      //   sort: "urgency",
      //   sortOrder: "DESC",
      //   urgency: "All",
      //   authoredByMe: false,
      //   raisedByMe: false,
      //   taxonomyId: 0,
      //   knowledgeSourceId: 0,
      //   documentId: 0,
      //   includeUnattached: true,
      //   taxonomyNode: { name: "" },
      // },
      // showFilters: false,
      // filterAnchorEl: null,
      unreadDiscussions: 0,
      page: 0,
      isAtEnd: false,
      revisionSummary: null,
    };
  }

  componentDidMount() {
    this.getData();
    this.getDiscussionSummary();
    if (this.props.location.pathname.indexOf("/revision") > 0
    ) {
      this.getRevision(this.props.location.pathname.replace(`${this.props.match.url}/revision/`,''))
    }
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.location.pathname.indexOf("/revision") > 0 &&
      this.props.location.pathname.indexOf("/revision") < 0
    ) {
      this.setState({ diff: false, diffRevisionNumber: null });
    }
    if (prevProps.location.pathname !== this.props.location.pathname) {
      let location = this.props.location.pathname;
      if (!/(\/full\/knowledgeitem\/[A-Za-z0-9\-]*\/.*)/.test(location)) {
        this.getData();
        (this.state.selected === 3 || this.state.selected === 2) && 
          this.setState({ page: 0, isAtEnd: false}, () => {this.getRevisions()});
      }
    }
    this.state.editViewedRevision === true &&
      this.props.location.pathname.indexOf("/revision") < 0 &&
      this.setState({ editViewedRevision: false });
  }
  getData() {
    contentClient
      .get(`/knowledgeitem/${this.props.kiId}`)
      .then((res) => {
        this.setState(
          { knowledgeItem: res.data, tempKnowledgeItem: res.data },
          () => {
            if (
              this.props.location.state &&
              this.props.location.state.discussionId
            ) {
              this.setState({ selected: 2 });
            }
          }
        );
      })
      .catch((err) => {
        console.log(err);
        this.props.history.push({
          pathname: `/`,
        });
      });
  }
  toggleSidebar = () => {
    this.setState((prev) => ({ sidebarOpen: !prev.sidebarOpen }));
  };
  getRevisions = () => {
    if (this.state.isAtEnd) return;
    contentClient
      .get(`/knowledgeitem/${this.props.kiId}/revision/?page=${this.state.page}&size=20`)
      .then((res) => {
        if (res.data.last) {
          this.setState({ isAtEnd: true });
        } else {
          this.setState({ page: this.state.page + 1 });
        }
        if (res.data.number === 0) {
          this.setState({
            revisions: res.data.content,
          });
        } else {
          this.setState({ revisions: [...this.state.revisions, ...res.data.content] });
        }
      });
  };
  getRevision = (revisionNumber) => {
    //here is a catch all for when the page is refreshed when displaying a revision
    contentClient
      .get(`/knowledgeitem/${this.props.kiId}/revision/number/${revisionNumber}/content`)
      .then((res) => {
        this.setState({ selectedRevision: res.data });
      });
  };

  getDiscussionSummary = () => {
    let url = `/discussion/summary?type=KNOWLEDGE_ITEM&itemId=${
      this.props.kiId
    }`;
    discussionClient.get(url).then((res) => {
      // this.props.updateUnread && this.props.updateUnread(res.data ? res.data.unreadExpert : 0)
      this.setState({ unreadDiscussions: res.data.unreadExpert });
    });
  };

  hasKIBeenEdited = (newValue) => {
    let result = equal(this.state.knowledgeItem, newValue) ? false : true;
    return result;
  };

  onRevisionClick = (selectedRevision) => {
    this.setState({ selectedRevision }, () =>
      this.props.history.push(
        `${this.props.match.url}/revision/${selectedRevision.revisionNumber}`
      )
    );
  };
  saveKnowledgeItem = () => {
    contentClient
      .patch(`/knowledgeitem/${this.props.kiId}`, this.state.tempKnowledgeItem)
      .then((res) => {
        this.setState({
          knowledgeItem: res.data,
          tempKnowledgeItem: res.data,
          selected: 0,
          snackOpen: true,
          hasBeenEdited: false,
        });
        this.props.enqueueSnackbar("Knowledge item edited successfully", {
          variant: "success",
        });
        this.getRevisions();
      })
      .catch((err) => {
        this.props.enqueueSnackbar(
          "An error occurred processing your request",
          { variant: "error" }
        );
      });
  };
  // getTemplate = (id) => {
  //   contentClient.get(`/template/${id}`).then((res) => {
  //     this.setState({ selectedTemplate: res.data });
  //   });
  // };
  onSummaryLoaded = (timelineSummary) => {
    this.setState({revisionSummary: timelineSummary})
  }
  onRevisionAdded = (revision) => {
    this.props.history.goBack();
    this.setState({
      isAtEnd: false,
    }, () => {this.getRevisions();});
  };
  onNewRevision = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let revisionSummary = this.state.revisionSummary
    let rev = revisionSummary && revisionSummary.liveRevision
      ? revisionSummary.liveRevision
      : revisionSummary.draftRevision
        ? revisionSummary.draftRevision 
        : revisionSummary.latestBeingEdited;
    this.setState({
      selectedRevision: rev,
      createRevision: true,
    });
    // if (rev.layout || (rev.template && rev.template.id)) {
    //   this.getTemplate(rev.layout ? rev.layout : rev.template.id);
    // }
    this.props.history.push(`${this.props.match.url}/newrevision`);
  };
  onRevisionEdit = (edittedRevision) => {
    let copyRevisions = [...this.state.revisions];
    copyRevisions = copyRevisions.map((revision) => {
      if (revision.revisionId === edittedRevision.revisionId) {
        return edittedRevision;
      } else {
        return revision;
      }
    });
    // for (let i = 0; i < copyRevisions.length; {
    // 	if (copyRevisions[i].revisionId === edittedRevision.revisionId) {
    // 		copyRevisions[i] = edittedRevision;
    // 	}
    // }
    this.setState({ revisions: copyRevisions, selected: 0 });
  };
  submitEdit = () => {
    this.props.history.goBack();
    this.getRevisions();
  };
  routerDiscussion = (location) => {
    // this.state.selected != 4 && this.setState({ selected: 4 });
    return (
      <KnowledgeItemDiscussion
        revisionList={this.renderRevisionList}
        ki={this.state.knowledgeItem}
        discussionId={
          location.location.state && location.location.state.discussionId
        }
        updateUnread={this.getDiscussionSummary}
      />
    );
  };
  routerDocument = (location) => {
    const classes = this.props;
    return (
      <DocumentViewer
        // discussionId={this.getDiscussionId()}
        documentId={parseInt(this.state.knowledgeItem.documentId)}
        className={classes.docViewer}
        key={this.state.knowledgeItem.documentId}
      />
    );
  };
  routerCreateRevision = (location) => {
    const classes = this.props;
    return (
      <>
        {this.state.selectedRevision &&
          this.state.knowledgeItem && (
            <>
              {this.state.knowledgeItem.knowledgeSource && (
                <FormControl
                  variant="outlined"
                  className={classes.displayTemplate}
                  style={{ width: "100%", height: "98%" }}
                >
                  <Box
                    display="flex"
                    flexWrap="wrap"
                    justifyContent="left"
                    height="100%"
                  >
                    <Box width={300}>
                      <SidebarRework
                        toggleSidebar={this.toggleSidebar}
                        // toggleFilters={this.toggleFilters}
                        show={true}
                        hideCloseButton
                        hideFab
                        updateResolvingReworks={(resolvingReworks) =>
                          this.setState({ resolvingReworks })
                        }
                        // filter={{
                        //   knowledgeItemId: this.state.knowledgeItem.itemId,
                        // }}
                        // filter={this.state.filters}
                        internalDocument={{
                          contentRVO: this.state.knowledgeItem,
                        }}
                        false
                        isDraft={false}
                        editing={true}
                      />
                    </Box>
                    <CreateContentFlow
                      edit
                      revisionEdit
                      onRevisionAdded={this.onRevisionAdded}
                      onRevisionEdit={this.onRevisionEdit}
                      resolvingReworks={this.state.resolvingReworks}
                      createRevision={this.state.createRevision}
                      onClose={() =>
                        this.setState({ selected: 0 }, () =>
                          this.props.history.goBack()
                        )
                      }
                      onSubmit={this.submitEdit}
                      sections={this.state.selectedRevision.sectionsDTOs}
                      content={{
                        ...this.state.selectedRevision,
                        knowledgeSourceId: this.state.knowledgeItem
                          .knowledgeSource.sourceId,
                        makeDraft: false,
                        publishContent: false,
                        documentTypeId: this.state.knowledgeItem.documentTypeId,
                      }}
                      // template={this.state.selectedTemplate}
                      revisions={this.state.revisions}
                    />
                  </Box>
                </FormControl>
              )}
            </>
          )}
      </>
    );
  };
  updateDocumentWorkflow = (revision) => {
    this.setState({
      selectedRevision: {
        ...this.state.selectedRevision,
        ...revision,
      },
    });
  };
  routerDisplayRevision = (location) => {
    const classes = this.props;
    const revisionEdit = true;
    return (
      <>
        {this.state.selectedRevision &&
          this.state.selectedRevision.revisionId &&
          this.state.knowledgeItem &&
          this.state.knowledgeItem.itemId && (
            <>
              {!this.state.editViewedRevision === true ? (
                <div
                  id="revision-view-container"
                  style={{ display: "flex", flex: "1 1 100%", maxHeight: "93%" }}
                >
                  <DocumentSidebar
                    isRevision
                    workflowState={this.state.selectedRevision.workflowState}
                    doWorkflow={() => {}}
                    updateDocumentWorkflow={this.updateDocumentWorkflow}
                    diffRevisionNumber={this.state.diffRevisionNumber}
                    doDiff={() => {
                      this.setState({
                        diff: true,
                        diffRevisionNumber: this.state.liveRevision
                          ? this.state.liveRevision.revisionNumber
                          : null,
                      });
                    }}
                    reset={() => {
                      this.setState({ diff: false, diffRevisionNumber: null });
                    }}
                    onRevisionDiffChange={(rev) =>
                      this.setState({ diffRevisionNumber: rev.revisionNumber })
                    }
                    internalDocument={{
                      contentRVO: {
                        ...this.state.knowledgeItem,
                        authorId: this.state.selectedRevision.author.userId,
                        revisionId: this.state.selectedRevision.revisionId,
                        revisionNumber: this.state.selectedRevision
                          .revisionNumber,
                        reviewers:
                          this.state.selectedRevision.reviewedBy &&
                          this.state.selectedRevision.reviewedBy !== null
                            ? this.state.selectedRevision.reviewedBy
                            : [],
                        approvers:
                          this.state.selectedRevision.approvedBy &&
                          this.state.selectedRevision.approvedBy !== null
                            ? this.state.selectedRevision.approvedBy
                            : [],
                        hasReviews:
                          this.state.selectedRevision.reviewedBy !== null
                            ? this.state.selectedRevision.reviewedBy.length
                            : 0,
                        requiresReviews: this.state.knowledgeItem
                          .knowledgeSource.workflow.reviewersRequired,
                        hasApprovals:
                          this.state.selectedRevision.approvedBy !== null
                            ? this.state.selectedRevision.approvedBy.length
                            : 0,
                        requiresApprovals: this.state.knowledgeItem
                          .knowledgeSource.workflow.approversRequired,
                        reviewOwn: this.state.knowledgeItem.knowledgeSource
                          .workflow.reviewOwnKnowledge,
                        approveOwn: this.state.knowledgeItem.knowledgeSource
                          .workflow.approveOwnKnowledge,
                        publishedBy: this.state.selectedRevision.publishedBy,
                        madeDraftBy: this.state.selectedRevision.madeDraftBy,
                        workflowState: this.state.selectedRevision
                          .workflowState,
                        workflow: this.state.knowledgeItem.knowledgeSource
                          .workflow,
                      },
                      workflowState: this.state.selectedRevision.workflowState,
                    }}
                  />
                  {this.state.diff ? (
                    <DiffRevisions
                      template={this.state.selectedRevision}
                      hasDraft={this.state.knowledgeItem.hasDraft}
                      draft={this.state.selectedRevision.isDraft}
                      // toggleDraft={this.toggleDraft}
                      title={
                        this.state.selectedRevision
                          ? this.state.selectedRevision.title
                          : ""
                      }
                      currentRevision={{
                        ...this.state.selectedRevision,
                        contentRVO: {
                          itemId: this.state.knowledgeItem.itemId,
                        },
                      }}
                      diffRevisionNumber={this.state.diffRevisionNumber}
                    />
                  ) : (
                    <DisplayTemplate
                      customFields={this.state.selectedRevision.customFields}
                      isNotTemplate
                      isRevision
                      editTemplate={() => {
                        // this.state.selectedRevision.layout &&
                        // this.getTemplate(this.state.selectedRevision.layout);
                        this.setState({ editViewedRevision: true });
                      }}
                      revisionEdit
                      template={this.state.selectedRevision}
                      title={
                        this.state.selectedRevision
                          ? this.state.selectedRevision.title
                          : ""
                      }
                      currentRevision={this.state.selectedRevision}
                      draft={this.state.selectedRevision.isDraft}
                      documentId={this.state.knowledgeItem.documentId}
                      hasDraft={this.state.knowledgeItem.hasDraft}
                      hasLive={this.state.knowledgeItem.hasLive}
                    />
                  )}
                </div>
              ) : (
                <CreateContentFlow
                  edit
                  noBackground
                  revisionEdit
                  onRevisionAdded={this.onRevisionAdded}
                  onRevisionEdit={this.onRevisionEdit}
                  createRevision={false}
                  onClose={() => this.setState({ editViewedRevision: false })}
                  onSubmit={() =>
                    this.setState(
                      { editViewedRevision: false },
                      this.submitEdit
                    )
                  }
                  sections={this.state.selectedRevision.sectionsDTOs}
                  content={{
                    ...this.state.selectedRevision,
                    knowledgeSourceId: this.state.knowledgeItem.knowledgeSource
                      .sourceId,
                    makeDraft: false,
                    publishContent: false,
                    documentTypeId: this.state.knowledgeItem.documentTypeId,
                  }}
                  // template={this.state.selectedTemplate}
                  revisions={this.state.revisions}
                />
              )}
            </>
          )}
      </>
    );
  };
  // toggleFilters = (e) => {
  //   this.state.filterAnchorEl === null &&
  //     this.setState({ filterAnchorEl: e.currentTarget });
  //   this.setState((prev) => ({ showFilters: !prev.showFilters }));
  // };
  handleChange = (event, newValue) => {
    // (newValue === 3 || newValue === 2) && this.getRevisions()
    this.setState({ selected: newValue , page:0, isAtEnd: false}, () => {(newValue === 3 || newValue === 2) && this.getRevisions()});
  };
  setKnowledgeSourceTopic = (node) => {
    if (node.object) {
      const newSource = {
        ...this.state.tempKnowledgeItem.knowledgeSource,
        topicId: node.object.topicId,
        sourceId:
          node.object.topicId !==
          this.state.knowledgeItem.knowledgeSource.topicId
            ? -1
            : this.state.knowledgeItem.knowledgeSource.topicId,
      };
      const newValue = {
        ...this.state.tempKnowledgeItem,
        knowledgeSource: newSource,
        topic: {
          ...this.state.knowledgeItem.topic,
          topicId: node.object.topicId,
          topicName: node.name,
        },
      };
      this.setState({
        tempKnowledgeItem: newValue,
        hasBeenEdited: this.hasKIBeenEdited(newValue),
      });
    }
  };
  setKnowledgeSourceClassification = (e) => {
    const newSource = {
      ...this.state.tempKnowledgeItem.knowledgeSource,
      classification: e.target.value,
      sourceId:
        e.target.value !==
        this.state.knowledgeItem.knowledgeSource.classification
          ? -1
          : this.state.knowledgeItem.knowledgeSource.classification,
    };
    const newValue = {
      ...this.state.tempKnowledgeItem,
      knowledgeSource: newSource,
    };
    this.setState({
      tempKnowledgeItem: newValue,
      hasBeenEdited: this.hasKIBeenEdited(newValue),
    });
  };

  getWorkflowTooltip = (revision) => {
    if (revision.isLive === true && revision.workflowState === "PUBLISHED") {
      return <Trans i18nKey="global_publish_past_tense" />;
    } else if (
      revision.isLive === false &&
      (revision.workflowState === "PUBLISHED" ||
        revision.workflowState === "SUPERCEDED")
    ) {
      return <Trans i18nKey="workflow_superseded" />;
    } else if (revision.workflowState === "AWAITING_REVIEW") {
      return <Trans i18nKey="filter_knowledge_items_awaiting_review" />;
    } else if (revision.workflowState === "AWAITING_APPROVAL") {
      return <Trans i18nKey="filter_knowledge_items_awaiting_approval" />;
    } else if (revision.workflowState === "AWAITING_PUBLISH") {
      return <Trans i18nKey="filter_knowledge_items_awaiting_publish" />;
    } else if (revision.workflowState === "REMOVED_FROM_DRAFT") {
      return <Trans i18nKey="workflow_removed_from_draft" />;
    }
  };
  // onFilterChange = (filter) => {
  //   this.setState({
  //     filters: filter,
  //   });
  // };
  getWorkflowIcon = (revision) => {
    const { theme } = this.props;
    const workflow = this.state.knowledgeItem.knowledgeSource.workflow;
    const reviewersRequired = workflow.reviewersRequired > 0;
    const approversRequired = workflow.approversRequired > 0;
    let icon = "";
    let revState =
      revision.workflowState === "PUBLISHED" && revision.isLive === false
        ? "SUPERCEDED"
        : revision.workflowState;
    switch (revState) {
      case null:
        if (revision.isLive) {
          icon = published;
        } else if (revision.isDraft) {
          icon = draft;
        }
        break;
      case "PUBLISHED":
        icon = published;
        break;
      case "AWAITING_REVIEW":
        icon = reviewer;
        break;
      case "AWAITING_APPROVAL":
        icon = approver;
        break;
      case "AWAITING_PUBLISH":
        if (!reviewersRequired && !approversRequired) {
          icon = draft;
        } else {
          icon = published;
        }
        break;
      case "SUPERCEDED":
        icon = superseded;
        break;
      case "REMOVED_FROM_DRAFT":
        icon = removedFromDraft;
        break;
    }

    return (
      <>
        <SvgIcon>
          <path d={icon} />
        </SvgIcon>
      </>
    );
  };
  setScrolling = (scrolling) => {
    this.state.scrolling != scrolling &&
      this.setState({ scrolling: scrolling });
  };
  revisionRowRenderer = (idx) => {
    const { classes, theme } = this.props;
    const revision = this.state.revisions[idx];
    if (!revision) {
      return <div style={{ height: 1 }} />;
    }
    return (
      <Container maxWidth="sm">
      <ListItem>
        {/* {(this.state.knowledgeItem.knowledgeSource.workflow.approversRequired > 0 ||
          this.state.knowledgeItem.knowledgeSource.workflow.reviewersRequired > 0) && */}
        <Tooltip title={this.getWorkflowTooltip(revision)}>
          <Avatar
            classes={{
              root:
                revision.workflowState === null
                  ? revision.isLive === true
                    ? classes.publishedAvatar
                    : classes.disabledAvatar
                  : revision.workflowState === "PUBLISHED"
                    ? classes.publishedAvatar
                    : revision.workflowState ===
                        "AWAITING_PUBLISH" &&
                      (this.state.knowledgeItem.knowledgeSource
                        .workflow.approversRequired === 0 ||
                        this.state.knowledgeItem.knowledgeSource
                          .workflow.reviewersRequired === 0)
                      ? classes.draftAvatar
                      : revision.workflowState === "SUPERCEDED"
                        ? classes.draftAvatar
                        : classes.waitingAvatar,
            }}
          >
            {/* <ListItemIcon> */}
            {this.getWorkflowIcon(revision)}
            {/* </ListItemIcon>    */}
          </Avatar>
        </Tooltip>
        {/* } */}
        {/* <ListItemText inset={revision.workflowState === null} primary={ */}
        <ListItemText
          primary={
            <Box display="flex">
              {/* {revision.isLive ? <div>Live</div> : revision.isDraft ? <div>Draft</div> : <></>}                    */}
              <ItemContentRevision
                key={"live"}
                onItemClick={this.onRevisionClick}
                data={revision}
                onRevisionClick={this.onRevisionClick}
                extendedSettings={JSON.stringify([
                  {
                    label:
                      "settings_content_revision_created_date",
                    order: 0,
                  },
                  {
                    label: "settings_content_revision_rationale",
                    order: 1,
                  },
                ])}
                secondarySetting={"author"}
              />
            </Box>
          }
        />
      </ListItem>
      </Container>
    );
  };
  renderRevisionList = () => {
    return (
      <Virtuoso
        overscan={10}
        totalCount={this.state.revisions.length}
        itemContent={(idx) => this.revisionRowRenderer(idx)}
        defaultItemHeight={63}
        endReached={(idx) => {
          this.getRevisions(idx);
        }}
        style={{ width: "100%", height: "100%" }}
      />
    )
  }
  render() {
    let currentPath = this.props.match.url;
    const { classes, theme } = this.props;
    let discussionEnabled =
      this.props.applicationProperties[PropertyNames.DISCUSSIONS_ENABLED] ===
      "true";
    return (
      <>
        <Route
          exact
          path={`${this.props.match.url}/document/${
            this.state.knowledgeItem.documentId
          }`}
          component={this.routerDocument}
        />
        <Route
          exact
          path={`${this.props.match.url}/newrevision`}
          component={this.routerCreateRevision}
        />
        <Route
          path={`${this.props.match.url}/revision`}
          component={this.routerDisplayRevision}
        />
        <Route exact path="/full/knowledgeitem/:kiId">
          <Tabs
            id="kitabs"
            value={this.state.selected}
            centered={!this.props.isMobile}
            fullWidth
            scrollButtons={this.props.isMobile ? "on" : "auto"}
            onChange={this.handleChange}
            // variant="scrollable"
            style={{
              marginBottom: theme.spacing(3),
              borderBottom: "1px solid #e8e8e8",
            }}
          >
            <Tab
              value={0}
              disabled={Object.keys(this.state.knowledgeItem).length === 0}
              label={
                <span
                  style={{
                    marginBottom: theme.spacing(1),
                    marginLeft: theme.spacing(1),
                  }}
                >
                  <Typography>
                    <Trans i18nKey="knowledge_item_view_information" />
                  </Typography>
                </span>
              }
              icon={
                <InfoIcon
                  className={classes.green}
                  style={{ paddingRight: theme.spacing(1) }}
                />
              }
              classes={{ wrapper: classes.tabTitle }}
            />
            <Tab
              value={1}
              disabled={Object.keys(this.state.knowledgeItem).length === 0}
              label={
                <span
                  style={{
                    marginBottom: theme.spacing(1),
                    marginLeft: theme.spacing(1),
                  }}
                >
                  <Typography>
                    <Trans i18nKey="global_rework_plural" />
                  </Typography>
                </span>
              }
              icon={
                <Badge
                  color="secondary"
                  badgeContent={this.state.knowledgeItem.openReworks}
                >
                  <FlagIcon />
                </Badge>
              }
              classes={{ wrapper: classes.tabTitle }}
            />
            {discussionEnabled &&
              !this.props.isMobile && (
                <Tab
                  value={2}
                  disabled={Object.keys(this.state.knowledgeItem).length === 0}
                  id="ki-discussions"
                  label={
                    <span
                      style={{
                        marginBottom: theme.spacing(1),
                        marginLeft: theme.spacing(1),
                      }}
                    >
                      <Typography>
                        <Trans i18nKey="global_discussion_plural" />
                      </Typography>
                    </span>
                  }
                  icon={
                    <Badge
                      color="secondary"
                      badgeContent={this.state.unreadDiscussions}
                    >
                      <MessageIcon style={{ paddingRight: theme.spacing(1) }} />
                    </Badge>
                  }
                  classes={{ wrapper: classes.tabTitle }}
                />
              )}
            <Tab
              value={3}
              disabled={Object.keys(this.state.knowledgeItem).length === 0}
              label={
                <span
                  style={{
                    marginBottom: theme.spacing(1),
                    marginLeft: theme.spacing(1),
                  }}
                >
                  <Typography>
                    <Trans i18nKey="revision_history" />
                  </Typography>
                </span>
              }
              icon={
                // <Badge
                //   color="secondary"
                //   badgeContent={this.state.revisions.length}
                // >
                <HistoryIcon style={{ paddingRight: theme.spacing(1) }} />
                // </Badge>
              }
              classes={{ wrapper: classes.tabTitle }}
            />
          </Tabs>
          <SwipeableViews
            index={this.state.selected}
            style={{ height: "100%" }}
            slideClassName="swipeable-slide"
            slideStyle={{ overflowX: "hidden", overflowY: "hidden", width: "100%" }}
          >
            <Box display="flex" flexWrap="wrap" justifyContent="center">
              <div style={{ flex: 1, padding: "0px 50px" }}>
                {Object.keys(this.state.knowledgeItem).length === 0 ? (
                  <div>
                    <Skeleton
                      variant="rect"
                      style={{ width: "80%", marginBottom: 20 }}
                      height={50}
                      animation="wave"
                    />
                    <div style={{ display: "flex", marginBottom: 20 }}>
                      <Skeleton
                        variant="rect"
                        style={{ width: "25%", marginRight: 40 }}
                        height={20}
                        animation="wave"
                      />
                      <Skeleton
                        variant="rect"
                        style={{ width: "25%", marginRight: 20 }}
                        height={20}
                        animation="wave"
                      />
                    </div>
                    <div style={{ display: "flex", marginBottom: 20 }}>
                      <Skeleton
                        variant="rect"
                        style={{ width: "25%", marginRight: 40 }}
                        height={20}
                        animation="wave"
                      />
                      <Skeleton
                        variant="rect"
                        style={{ width: "25%", marginRight: 20 }}
                        height={20}
                        animation="wave"
                      />
                    </div>
                    <div style={{ display: "flex", marginBottom: 20 }}>
                      <Skeleton
                        variant="rect"
                        style={{ width: "25%", marginRight: 40 }}
                        height={20}
                        animation="wave"
                      />
                      <Skeleton
                        variant="rect"
                        style={{ width: "25%", marginRight: 20 }}
                        height={20}
                        animation="wave"
                      />
                    </div>
                    <Skeleton
                      variant="rect"
                      style={{ width: "60%", marginBottom: 20 }}
                      height={100}
                      animation="wave"
                    />
                    <div style={{ display: "flex", marginBottom: 10 }}>
                      <Skeleton
                        variant="rect"
                        style={{ width: "25%", marginRight: 40 }}
                        height={20}
                        animation="wave"
                      />
                      <Skeleton
                        variant="rect"
                        style={{ width: "25%", marginRight: 20 }}
                        height={20}
                        animation="wave"
                      />
                    </div>
                    <div style={{ display: "flex", marginBottom: 40 }}>
                      <Skeleton
                        variant="rect"
                        style={{ width: "25%", marginRight: 40 }}
                        height={20}
                        animation="wave"
                      />
                      <Skeleton
                        variant="rect"
                        style={{ width: "25%", marginRight: 20 }}
                        height={20}
                        animation="wave"
                      />
                    </div>
                    <div style={{ display: "flex", marginBottom: 10 }}>
                      <Skeleton
                        variant="rect"
                        style={{
                          width: "15%",
                          marginRight: 30,
                          marginLeft: 50,
                        }}
                        height={40}
                        animation="wave"
                      />
                      <Skeleton
                        variant="rect"
                        style={{ width: "15%", marginRight: 30 }}
                        height={40}
                        animation="wave"
                      />
                      <Skeleton
                        variant="rect"
                        style={{ width: "15%", marginRight: 30 }}
                        height={40}
                        animation="wave"
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <div>
                      {this.state.tempKnowledgeItem.openReworks > 0 && (
                        <Alert severity="warning">
                          There{" "}
                          {this.state.tempKnowledgeItem.openReworks > 1
                            ? "are"
                            : "is"}{" "}
                          {this.state.tempKnowledgeItem.openReworks} Rework(s)
                          Open for this item
                        </Alert>
                      )}
                    </div>
                    <div>
                      {this.state.tempKnowledgeItem.withdrawDate !== null && (
                        <Alert severity="warning">
                          Withdrawn{" "}
                          {this.state.knowledgeItem.withdrawDate !== null
                            ? moment(
                                this.state.knowledgeItem.withdrawDate
                              ).fromNow()
                            : ""}{" "}
                          - not available to search or view
                        </Alert>
                      )}
                    </div>
                    <div>
                      {this.state.tempKnowledgeItem.revalidationDate !== null &&
                      moment(
                        this.state.tempKnowledgeItem.revalidationDate
                      ).isValid() ? (
                        this.state.tempKnowledgeItem.revalidationDate <=
                        new Date() ? (
                          <Alert severity="error">
                            {this.props.t("global_revalidation global_required")}{" "}
                            {this.state.tempKnowledgeItem.revalidationDate !==
                            null
                              ? moment(
                                  this.state.tempKnowledgeItem.revalidationDate
                                ).fromNow()
                              : ""}
                          </Alert>
                        ) : (
                          <Alert severity="info">
                            {this.props.t("global_revalidation global_required")}{" "}
                            {this.state.tempKnowledgeItem.revalidationDate !==
                            null
                              ? moment(
                                  this.state.tempKnowledgeItem.revalidationDate
                                ).fromNow()
                              : ""}
                          </Alert>
                        )
                      ) : (
                        <></>
                      )}
                    </div>
                    <Table size="small">
                      <TableBody>
                      {this.state.knowledgeItem.topic && (
                        <TableRow>
                          <TableCell
                            classes={{ root: classes.tableCellNoBorder }}
                          >
                            <Trans i18nKey="global_topic" />
                          </TableCell>
                          <TableCell
                            classes={{ root: classes.tableCellNoBorder }}
                          >
                            <Box display="flex" alignItems="center">
                              {/* <div style={{marginRight: theme.spacing(1)}}>
                              <svg height="24px" width="24px">
                                <path
                                  fill={`${this.props.theme.palette.primary.dark}`}
                                  d={topicSVG}
                                />
                              </svg>
                            </div>
                            <div>
                              {this.state.knowledgeItem.topic.topicName}
                            </div> */}
                              <TaxonomySelector
                                fullWidth
                                showWorkflow
                                noLabel={true}
                                error={false}
                                onTouch={() => true}
                                disabled={false}
                                allowedSelections={["topic"]}
                                filter={
                                  this.state.tempKnowledgeItem.topic.topicId
                                    ? [
                                        {
                                          id: this.state.tempKnowledgeItem.topic
                                            .topicId,
                                          type: "topic",
                                        },
                                      ]
                                    : []
                                }
                                onNodeSelected={this.setKnowledgeSourceTopic}
                                treeType="expert"
                              />
                            </Box>
                          </TableCell>
                        </TableRow>
                      )}
                      {this.state.knowledgeItem.knowledgeSource && (
                        <TableRow>
                          <TableCell
                            classes={{ root: classes.tableCellNoBorder }}
                          >
                            <Trans i18nKey="add_section_classification" />
                          </TableCell>
                          <TableCell
                            classes={{ root: classes.tableCellNoBorder }}
                          >
                            {/* {this.state.knowledgeItem.knowledgeSource.classification === 0 ?
                            "Public" :
                            "Level " + this.state.knowledgeItem.knowledgeSource.classification
                          } */}
                            <Select
                              onClick={(e) => {
                                {
                                  this.setKnowledgeSourceClassification(e);
                                }
                              }}
                              value={
                                this.state.tempKnowledgeItem.knowledgeSource
                                  .classification
                                  ? this.state.tempKnowledgeItem.knowledgeSource
                                      .classification
                                  : 0
                              }
                            >
                              <MenuItem value={0}>{this.props.t("global_public")}</MenuItem>
                              <MenuItem value={1}>{this.props.t("global_level") + " 1"}</MenuItem>
                              <MenuItem value={2}>{this.props.t("global_level") + " 2"}</MenuItem>
                              <MenuItem value={3}>{this.props.t("global_level") + " 3"}</MenuItem>
                              <MenuItem value={4}>{this.props.t("global_level") + " 4"}</MenuItem>
                              <MenuItem value={5}>{this.props.t("global_level") + " 5"}</MenuItem>
                            </Select>
                          </TableCell>
                        </TableRow>
                      )}
                      <TableRow>
                        <TableCell
                          classes={{ root: classes.tableCellNoBorder }}
                        >
                          <Trans i18nKey="knowledge_item_view_document_id" />
                        </TableCell>
                        <TableCell
                          classes={{ root: classes.tableCellNoBorder }}
                        >
                          <Link
                            id="ki-view-document-link"
                            component="button"
                            onClick={() => {
                              this.props.history.push(
                                this.props.match.url +
                                  "/document/" +
                                  this.state.knowledgeItem.documentId
                              );
                            }}
                          >
                            {this.state.knowledgeItem.documentId}
                          </Link>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          classes={{ root: classes.tableCellNoBorder }}
                        >
                          <Trans i18nKey="global_author" />
                        </TableCell>
                        <TableCell
                          classes={{ root: classes.tableCellNoBorder }}
                        >
                          {this.state.knowledgeItem.hasOwnProperty("author") &&
                            this.state.knowledgeItem.author !== null && (
                              <DisplayUser
                                userId={this.state.knowledgeItem.author.userId}
                                user={this.state.knowledgeItem.author}
                              />
                            )}
                          <Typography variant="subtitle2">
                            {this.state.knowledgeItem.createdDate !== null
                              ? moment(
                                  this.state.knowledgeItem.createdDate
                                ).fromNow()
                              : ""}
                          </Typography>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          classes={{ root: classes.tableCellNoBorder }}
                        >
                          <Trans i18nKey="settings_document_live_revision_author" />
                        </TableCell>
                        <TableCell
                          classes={{ root: classes.tableCellNoBorder }}
                        >
                          {this.state.liveRevision &&
                            this.state.liveRevision.author !== null && (
                              <DisplayUser
                                userId={this.state.liveRevision.author.userId}
                                user={this.state.liveRevision.author}
                              />
                            )}
                          <Typography variant="subtitle2">
                            {this.state.liveRevision &&
                            this.state.liveRevision.createdDate !== null
                              ? moment(
                                  this.state.liveRevision.createdDate
                                ).fromNow()
                              : ""}
                          </Typography>
                        </TableCell>
                      </TableRow>

                      {this.state.knowledgeItem.createdDate !==
                        this.state.knowledgeItem.modifiedDate && (
                        <TableRow>
                          <TableCell
                            classes={{ root: classes.tableCellNoBorder }}
                          >
                            <Trans i18nKey="knowledge_item_view_modified_by" />
                          </TableCell>
                          <TableCell
                            classes={{ root: classes.tableCellNoBorder }}
                          >
                            {this.state.knowledgeItem.hasOwnProperty(
                              "lastModifiedBy"
                            ) &&
                              this.state.knowledgeItem.lastModifiedBy !==
                                null && (
                                <DisplayUser
                                  userId={
                                    this.state.knowledgeItem.lastModifiedBy
                                      .userId
                                  }
                                  user={this.state.knowledgeItem.lastModifiedBy}
                                />
                              )}
                            <Typography variant="subtitle2">
                              {this.state.knowledgeItem.modifiedDate !== null
                                ? moment(
                                    this.state.knowledgeItem.modifiedDate
                                  ).fromNow()
                                : ""}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                      <TableRow>
                        <TableCell
                          colSpan={2}
                          classes={{ root: classes.tableCellNoBorder }}
                        >
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            fullWidth
                          >
                            <KpsTextField
                              multiline
                              className={classes.textField}
                              onChange={(e) => {
                                const newDescription =
                                  e.target.value.trim() === ""
                                    ? this.state.knowledgeItem.description ===
                                      null
                                      ? null
                                      : ""
                                    : e.target.value;
                                const newValue = {
                                  ...this.state.tempKnowledgeItem,
                                  description: newDescription,
                                };
                                this.setState({
                                  tempKnowledgeItem: newValue,
                                  hasBeenEdited: this.hasKIBeenEdited(newValue),
                                });
                              }}
                              label={<Trans i18nKey="global_description" />}
                              rows={1}
                              variant="outlined"
                              color="primary"
                              // defaultValue={this.state.tempKnowledgeItem.description}
                              value={
                                this.state.tempKnowledgeItem.description
                                  ? this.state.tempKnowledgeItem.description
                                  : ""
                              }
                            />
                          </FormControl>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          colSpan={2}
                          classes={{ root: classes.tableCellNoBorder }}
                        >
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            fullWidth
                          >
                            <DocumentType
                              doctypes={this.props.docTypes}
                              docTypeSelected={(e) => {
                                const newValue = {
                                  ...this.state.tempKnowledgeItem,
                                  documentTypeId: e.target.value,
                                };
                                this.setState({
                                  tempKnowledgeItem: newValue,
                                  hasBeenEdited: this.hasKIBeenEdited(newValue),
                                });
                              }}
                              documentType={[
                                this.state.tempKnowledgeItem.documentTypeId,
                              ]}
                            />
                          </FormControl>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          colSpan={2}
                          classes={{ root: classes.tableCellNoBorder }}
                        >
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            fullWidth
                          >
                            <DocumentCategories
                              defaultValue={
                                this.state.tempKnowledgeItem.categories
                              }
                              onChange={(categories) => {
                                const newValue = {
                                  ...this.state.tempKnowledgeItem,
                                  categories: categories.map((c) => c.id),
                                };
                                this.setState({
                                  tempKnowledgeItem: newValue,
                                  hasBeenEdited: this.hasKIBeenEdited(newValue),
                                });
                              }}
                            />
                          </FormControl>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          classes={{ root: classes.tableCellNoBorder }}
                        >
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                          >
                            <KeyboardDatePicker
                              format="DD/MM/YYYY"
                              autoOk
                              id="revalidation-date"
                              label={
                                <Trans i18nKey="content_setup_revalidation_date" />
                              }
                              clearable
                              value={
                                this.state.tempKnowledgeItem.revalidationDate
                              }
                              onChange={(date) => {
                                const newValue = {
                                  ...this.state.tempKnowledgeItem,
                                  revalidationDate: moment(date).valueOf(),
                                };
                                this.setState({
                                  tempKnowledgeItem: newValue,
                                  hasBeenEdited: this.hasKIBeenEdited(newValue),
                                });
                              }}
                            />
                          </FormControl>
                        </TableCell>
                        <TableCell
                          classes={{ root: classes.tableCellNoBorder }}
                        >
                          {this.state.tempKnowledgeItem.revalidationDate && (
                            <FormControl
                              className={classes.formControl}
                              style={{ width: "100%" }}
                            >
                              <InputLabel id="revalidation-behaviour-label">
                                <Trans i18nKey="settings_knowledge_item_revalidation_behaviour" />
                              </InputLabel>
                              <Select
                                id="revalidation-behaviour"
                                value={
                                  this.state.tempKnowledgeItem
                                    .revalidationBehaviour
                                }
                                defaultValue={"DO_NOTHING"}
                                onChange={(e) => {
                                  const newValue = {
                                    ...this.state.tempKnowledgeItem,
                                    revalidationBehaviour: e.target.value,
                                  };
                                  this.setState({
                                    tempKnowledgeItem: newValue,
                                    hasBeenEdited: this.hasKIBeenEdited(
                                      newValue
                                    ),
                                  });
                                }}
                              >
                                <MenuItem value={"DO_NOTHING"}>
                                  <Trans i18nKey="content_setup_do_nothing" />
                                </MenuItem>
                                <MenuItem value={"DISPLAY_WARNING"}>
                                  <Trans i18nKey="knowledge_item_view_display_warning" />
                                </MenuItem>
                                <MenuItem value={"HIDE_DOCUMENT"}>
                                  <Trans i18nKey="content_setup_hide_document" />
                                </MenuItem>
                                <MenuItem value={"NOT_SET"}>
                                  <Trans i18nKey="knowledge_item_view_not_set" />
                                </MenuItem>
                              </Select>
                            </FormControl>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          classes={{ root: classes.tableCellNoBorder }}
                        >
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                          >
                            <KeyboardDatePicker
                              format="DD/MM/YYYY"
                              autoOk
                              label={
                                <Trans i18nKey="settings_knowledge_item_visible_date" />
                              }
                              clearable
                              id="visible-date"
                              value={this.state.tempKnowledgeItem.visibleDate}
                              onChange={(date) => {
                                const newValue = {
                                  ...this.state.tempKnowledgeItem,
                                  visibleDate: moment(date).valueOf(),
                                };
                                this.setState({
                                  tempKnowledgeItem: newValue,
                                  hasBeenEdited: this.hasKIBeenEdited(newValue),
                                });
                              }}
                            />
                          </FormControl>
                        </TableCell>
                        <TableCell
                          classes={{ root: classes.tableCellNoBorder }}
                        >
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                          >
                            <KeyboardDatePicker
                              format="DD/MM/YYYY"
                              autoOk
                              id="expiry-date"
                              label={
                                <Trans i18nKey="settings_knowledge_item_expiry_date" />
                              }
                              clearable
                              value={this.state.tempKnowledgeItem.expiryDate}
                              onChange={(date) => {
                                const newValue = {
                                  ...this.state.tempKnowledgeItem,
                                  expiryDate: moment(date).valueOf(),
                                };
                                this.setState({
                                  tempKnowledgeItem: newValue,
                                  hasBeenEdited: this.hasKIBeenEdited(newValue),
                                });
                              }}
                            />
                          </FormControl>
                        </TableCell>
                      </TableRow>
                      </TableBody>
                    </Table>
                    <Box display="flex" flexWrap="wrap" justifyContent="center">
                      <>
                        {this.state.hasBeenEdited === true && (
                          <Button
                            className={classes.spacedButton}
                            onClick={() => {
                              this.setState({
                                tempKnowledgeItem: this.state.knowledgeItem,
                                hasBeenEdited: false,
                              });
                            }}
                            variant="contained"
                            color="primary"
                            size="medium"
                            startIcon={<ReplayIcon />}
                          >
                            {this.props.t("global_reset")}
                          </Button>
                        )}
                        {this.state.tempKnowledgeItem.withdrawDate === null && (
                          <Button
                            className={classes.spacedButton}
                            onClick={() => {
                              const newValue = {
                                ...this.state.tempKnowledgeItem,
                                withdrawDate: new Date().getTime(),
                              };
                              this.setState({
                                tempKnowledgeItem: newValue,
                                hasBeenEdited: this.hasKIBeenEdited(newValue),
                              });
                            }}
                            variant="contained"
                            color="primary"
                            size="medium"
                            startIcon={<VisibilityOffIcon />}
                          >
                            {this.props.t("global_withdraw")}
                          </Button>
                        )}
                        {this.state.tempKnowledgeItem.withdrawDate !== null && (
                          <Button
                            className={classes.spacedButton}
                            onClick={() => {
                              const newValue = {
                                ...this.state.tempKnowledgeItem,
                                withdrawDate: null,
                              };
                              this.setState({
                                tempKnowledgeItem: newValue,
                                hasBeenEdited: this.hasKIBeenEdited(newValue),
                              });
                            }}
                            variant="contained"
                            color="primary"
                            size="medium"
                            startIcon={<VisibilityIcon />}
                          >
                            {this.props.t("global_undo") + " " + this.props.t("global_withdraw")}
                          </Button>
                        )}
                        {this.state.hasBeenEdited === true && (
                          <Button
                            id="ki-view-save-button"
                            className={classes.spacedButton}
                            onClick={this.saveKnowledgeItem}
                            variant="contained"
                            color="secondary"
                            size="medium"
                            startIcon={<SaveIcon />}
                          >
                            <Trans i18nKey="global_save" />
                          </Button>
                        )}
                      </>
                    </Box>
                  </>
                )}
              </div>
              <div style={{ flex: 1, padding: "0px 50px" }}>
                {this.state.knowledgeItem.knowledgeSource ? (
                  <RevisionSummaryTimeline
                    // revisions={this.state.revisions}
                    knowledgeItem={this.state.knowledgeItem}
                    liveRevision={this.state.liveRevision}
                    onRevisionClick={this.onRevisionClick}
                    addRevision={this.onNewRevision}
                    onLoaded={this.onSummaryLoaded}
                  />
                ) : (
                  <div>
                    <Skeleton
                      variant="rect"
                      style={{
                        width: "15%",
                        marginBottom: 10,
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                      height={40}
                      animation="wave"
                    />
                    <Skeleton
                      variant="rect"
                      style={{
                        width: "1%",
                        marginBottom: 10,
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                      height={50}
                      animation="wave"
                    />
                    <Skeleton
                      variant="rect"
                      style={{
                        width: "30%",
                        marginBottom: 10,
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                      height={40}
                      animation="wave"
                    />
                    <Skeleton
                      variant="rect"
                      style={{
                        width: "1%",
                        marginBottom: 10,
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                      height={50}
                      animation="wave"
                    />
                    <Skeleton
                      variant="rect"
                      style={{
                        width: "30%",
                        marginBottom: 10,
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                      height={40}
                      animation="wave"
                    />
                    <Skeleton
                      variant="rect"
                      style={{
                        width: "1%",
                        marginBottom: 10,
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                      height={50}
                      animation="wave"
                    />
                    <Skeleton
                      variant="rect"
                      style={{
                        width: "30%",
                        marginBottom: 10,
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                      height={40}
                      animation="wave"
                    />
                    <Skeleton
                      variant="rect"
                      style={{
                        width: "1%",
                        marginBottom: 10,
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                      height={50}
                      animation="wave"
                    />
                    <Skeleton
                      variant="rect"
                      style={{
                        width: "30%",
                        marginBottom: 10,
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                      height={40}
                      animation="wave"
                    />
                  </div>
                )}
              </div>
            </Box>
            <Box height="100%">
              {this.state.selected === 1 && (
                <SidebarRework
                  toggleSidebar={this.toggleSidebar}
                  // toggleFilters={this.toggleFilters}
                  hideCloseButton
                  fullscreen
                  show={true}
                  // hideCloseButton
                  // filter={this.state.filters}
                  // filter={{ knowledgeItemId: this.state.knowledgeItem.itemId }}
                  internalDocument={{ contentRVO: this.state.knowledgeItem }}
                  false
                  isDraft={false}
                  editing={false}
                />
              )}
            </Box>
            <Box height="100%">
              {this.state.selected === 2 &&
                discussionEnabled && (
                  <>
                    <KnowledgeItemDiscussion
                      revisionList={this.renderRevisionList}
                      ki={this.state.knowledgeItem}
                      discussionId={
                        this.props.location.state
                          ? this.props.location.state.discussionId
                          : null
                      }
                      updateUnread={this.getDiscussionSummary}
                    />
                  </>
                )}
            </Box>

              {this.state.selected === 3 && (
                this.renderRevisionList()
             )}
          </SwipeableViews>
        </Route>
        {/* <FilterWrapper
          asPopper
          disablePortal
          open={this.state.showFilters}
          onClose={this.toggleFilters}
          anchorEl={this.state.filterAnchorEl}
          filterElement="FilterRework"
          filter={this.state.filters}
          onFilterChange={this.onFilterChange}
          isFilterBar={true}
          title={this.props.t("rework_filter_title")}
        /> */}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  docTypes: state.prefs.documentTypes,
  applicationProperties: state.setting.applicationProperties,
  isMobile: state.screen.isMobile,
});
export default connect(
  mapStateToProps,
  null
)(
  withTheme(
    withStyles(styles)(
      withRouter(withSnackbar(withTranslation()(KnowledgeItemView)))
    )
  )
);
